// The shape library of the sidebar (D-038): the "Mind Map Redesign" sidebar design, 33 shapes in four categories.
// `type` is the node type a dropped shape becomes; `words` are extra search terms; `icon` is the 32 × 32 icon path.
import { NODE_COLORS } from '../Shapes/shapeCatalog';

// `fill` / `stroke` draw the sidebar icons; `nodeColor` is the palette colour a dropped shape gets (D-042).
export const CATEGORIES = {
    basic: { label: 'Basic', fill: '#DCE7FF', stroke: '#2F6BFF', nodeColor: NODE_COLORS.blue },
    flow: { label: 'Flowchart', fill: '#D5F1DE', stroke: '#2E9A55', nodeColor: NODE_COLORS.green },
    arrows: { label: 'Arrows', fill: '#FFE6C7', stroke: '#E07A10', nodeColor: NODE_COLORS.orange },
    callouts: { label: 'Callouts', fill: '#ECE3FF', stroke: '#7B3FF2', nodeColor: NODE_COLORS.purple },
};

// What a dragged shape carries to the mind map's drop handler.
export const SHAPE_DRAG_TYPE = 'application/mindmap-shape';
export const SHAPE_COLOR_DRAG_TYPE = 'application/mindmap-shape-color';

export const CATEGORY_IDS = Object.keys(CATEGORIES);

// Shown under "Recently used" until the user has dragged shapes of their own.
export const DEFAULT_RECENT = ['Rounded rectangle', 'Decision', 'Database', 'Arrow'];

const ROWS = [
    ['Rectangle', 'basic', 'rectangle', 'box square', 'M4 8h24v16H4z'],
    ['Rounded rectangle', 'basic', 'round-rectangle', 'box card pill', 'M9 8h14a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5z'],
    ['Circle', 'basic', 'circle', 'round dot', 'M5 16a11 11 0 1 0 22 0a11 11 0 1 0-22 0z'],
    ['Ellipse', 'basic', 'ellipse', 'oval round', 'M3 16a13 8 0 1 0 26 0a13 8 0 1 0-26 0z'],
    ['Tall ellipse', 'basic', 'oval', 'oval vertical round', 'M8 16a8 13 0 1 0 16 0a8 13 0 1 0-16 0z'],
    ['Triangle', 'basic', 'triangle', 'arrow up', 'M16 5l12 21H4z'],
    ['Diamond', 'basic', 'diamond', 'rhombus decision', 'M16 4l12 12-12 12L4 16z'],
    ['Hexagon', 'basic', 'hexagon', 'polygon', 'M9 7h14l6 9-6 9H9l-6-9z'],
    ['Pentagon', 'basic', 'pentagon', 'polygon', 'M16 4l12 8.7-4.6 14.3H8.6L4 12.7z'],
    ['Octagon', 'basic', 'octagon', 'polygon stop', 'M11 4h10l7 7v10l-7 7H11l-7-7V11z'],
    ['Star', 'basic', 'star', 'favorite highlight', 'M16 4l3.5 7.2 7.9 1.1-5.7 5.6 1.4 7.9L16 22.1l-7.1 3.7 1.4-7.9-5.7-5.6 7.9-1.1z'],
    ['Plus', 'basic', 'plus', 'cross add', 'M12 4h8v8h8v8h-8v8h-8v-8H4v-8h8z'],
    ['Parallelogram', 'basic', 'parallelogram', 'slant skew', 'M10 8h19l-7 16H3z'],
    ['Trapezoid', 'basic', 'trapezoid', 'polygon', 'M9 8h14l6 16H3z'],
    ['Process', 'flow', 'rectangle', 'box step rectangle', 'M4 8h24v16H4z'],
    ['Decision', 'flow', 'diamond', 'diamond condition if', 'M16 4l12 12-12 12L4 16z'],
    ['Start or end', 'flow', 'start-end', 'terminator pill oval', 'M10 9h12a7 7 0 0 1 0 14H10a7 7 0 0 1 0-14z'],
    ['Data', 'flow', 'parallelogram', 'input output parallelogram', 'M10 8h19l-7 16H3z'],
    ['Database', 'flow', 'cylinder', 'cylinder storage db', 'M6 8.5v15c0 1.9 4.5 3.5 10 3.5s10-1.6 10-3.5v-15M6 8.5a10 3.5 0 1 0 20 0a10 3.5 0 1 0-20 0z'],
    ['Document', 'flow', 'document', 'page file paper', 'M5 6h22v17c-4 3-7-3-11 0s-7 3-11 0z'],
    ['Predefined process', 'flow', 'predefined-process', 'subroutine box', 'M4 8h24v16H4zM8 8v16M24 8v16'],
    ['Manual input', 'flow', 'manual-input', 'keyboard', 'M4 13l24-5v17H4z'],
    ['Delay', 'flow', 'delay', 'wait', 'M5 7h12a9 9 0 0 1 0 18H5z'],
    ['Off-page link', 'flow', 'off-page-link', 'connector pentagon', 'M6 5h20v14l-10 8-10-8z'],
    ['Arrow', 'arrows', 'arrow', 'right next', 'M3 12h15V6l11 10-11 10v-6H3z'],
    ['Double arrow', 'arrows', 'double-arrow', 'both ways swap', 'M3 16l7-8v5h12V8l7 8-7 8v-5H10v5z'],
    ['Arrow up', 'arrows', 'arrow-up', 'up increase', 'M16 3l11 11h-6v14h-10V14H5z'],
    ['Chevron', 'arrows', 'chevron', 'step next', 'M4 7h17l7 9-7 9H4l7-9z'],
    ['Arrow rectangle', 'arrows', 'arrow-rectangle', 'tag label flag', 'M4 9h17l7 7-7 7H4z'],
    ['Speech bubble', 'callouts', 'speech-bubble', 'comment chat message', 'M5 6h22a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H14l-6 5v-5H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z'],
    ['Cloud', 'callouts', 'cloud', 'idea thought', 'M9 24a6 6 0 0 1-.8-11.9A8 8 0 0 1 23.5 11a6.5 6.5 0 0 1-.5 13z'],
    ['Sticky note', 'callouts', 'sticky-note', 'note memo', 'M5 5h22v15l-7 7H5zM20 27v-7h7'],
    ['Heart', 'callouts', 'heart', 'love like', 'M16 27S4 19.5 4 11.5A6 6 0 0 1 16 9a6 6 0 0 1 12 2.5C28 19.5 16 27 16 27z'],
];

export const LIBRARY = ROWS.map(([name, category, type, words, icon]) => ({
    name,
    category,
    type,
    icon,
    searchText: `${name} ${words} ${CATEGORIES[category].label}`.toLowerCase(),
}));

export const shapeByName = (name) => LIBRARY.find((shape) => shape.name === name);

// Shapes whose name, related words or category contain `query`, within `category` ('all' for every category).
export const searchShapes = (query, category) => {
    const text = query.trim().toLowerCase();
    return LIBRARY.filter((shape) =>
        (category === 'all' || shape.category === category) && shape.searchText.includes(text));
};
